import { useMemo } from 'react';
import { useIsTripPlannerAvailableForArea } from '@alltrails/layout/hooks/tripPlannerAvailability';
import type { PlanATripMapBounds } from '@alltrails/layout/utils/tripPlannerSearchArea';
import { useAppSelector } from '@/utils/redux';

/** Trip planner availability for the area currently searched on the explore map, falling back to the viewport center. */
const useIsTripPlannerAvailableForSearchArea = (mapBounds?: PlanATripMapBounds) => {
  const boundingBox = useAppSelector(state => state.exploreService.boundingBox);

  const searchAreaCenter = useMemo(
    () =>
      boundingBox
        ? {
            lat: (boundingBox.topLeft.lat + boundingBox.bottomRight.lat) / 2,
            lng: (boundingBox.topLeft.lng + boundingBox.bottomRight.lng) / 2
          }
        : undefined,
    [boundingBox]
  );

  return useIsTripPlannerAvailableForArea({ mapBounds, mapCenter: searchAreaCenter });
};

export default useIsTripPlannerAvailableForSearchArea;
